import { Component, EventEmitter, Input, Output } from "@angular/core"
import { Product } from "src/app/meta/Product.interface"

@Component({
  selector: "ow-product-option",
  templateUrl: "./product-option.component.html"
})
export class ProductOptionComponent {
  @Input() product: Product | null = null
  @Input() isSelected = false
  @Input() isDisabled = false
  @Output() add = new EventEmitter<Product>()
  @Output() rem = new EventEmitter<Product>()

  public productFeatures: {[key: string]: string []} = {
    "AVM FRITZ!Box 7530 Ax": [
      "Wi-Fi 6 (WLAN AX) bis 1.800 MBit/s + 600 MBit/s",
      "Netzwerk mit 4 x Gigabit-LAN, 1 x USB",
      "Telefonanlage mit DECT-Basis für IP-basierte Anschlüsse",
      "Intelligentes WLAN Mesh für das Heimnetz",
      "Mediaserver, NAS, MyFRITZ!, Auto-Update"
    ],
    "AVM FRITZ!Box 7590 Ax": [
      "Wi-Fi 6 (WLAN AX) bis 2.400 MBit/s + 1.200 MBit/s",
      "4 x Gigabit-LAN, 1 x Gigabit-WAN, 2 x USB 3.0",
      "Telefonanlage, Schnurlostelefonie, Smart Home",
      "Intelligentes WLAN Mesh für das Heimnetz",
      "Mediaserver, NAS, MyFRITZ!, Auto-Update"
    ],
    "Business-Router Standard": [
      "Aktuell verwendetes Modell: AVM FRITZ!Box 7530 AX",
      "IP-basierte Telefonie",
      "4 x Gigabit-LAN; WAN über LAN 1",
      "WLAN Access Point IEEE 802.11ax, ac, n, g, a",
      "1 x USB-Anschluss für Speicher und Drucker",
      "Integrierte DECT-Basis für bis zu 6 Schnurlostelefone",
      "1 a/b-Port für analoges Telefon, Anrufbeantworter oder Fax"
    ],
    "Business-Router Premium": [
      "Aktuell verwendetes Modell: AVM FRITZ!Box 7690",
      "IP-basierte Telefonie",
      "1 x 2,5-Gigabit-WAN/LAN-Anschluss, für den Anschluss an das Glasfasermodem",
      "1 x 2,5-Gigabit-LAN-Anschluss",
      "2 x Gigabit-LAN",
      "Wi-Fi 7 auf 2,4 und 5 GHz",
      "1 x USB 2.0 für Speicher oder Mobilfunkstick",
      "DECT-Basis für bis zu 6 Schnurlostelefone",
      "2 a/b-Ports (wahlweise TAE/RJ11) zum Anschluss von analogen Telefonen, Anrufbeantworter und Fax"
    ]
  }

}
